import React, { useState , useEffect } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  Badge,
  Alert,
} from "reactstrap";

import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, Link, useHistory, useParams } from "react-router-dom";
import SignatureModal from "../../../components/SignatureModal";

import { userUpdate, userList } from "../../../store/actions";
import { postUserUpdate } from "../../../helpers/backend";

//Import Breadcrumb
import Loader from "../../../components/Common/Loader";
import ButtonVolver from "../../../components/ButtonVolver";

// Estilos CSS personalizados
const customStyles = `
  .user-edit-container {
    background: #F1F8E9;
    min-height: 100vh;
    padding: 20px 0;
  }

  .bg-gradient-primary {
    background:#C8E6C9;
  }

  .avatar-circle {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
  }

  .section-header {
    display: flex;
    background: #F1F8E9
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
  }

  .section-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
  }

  .form-control-modern {
    border: 2px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #fff;
  }

  .form-control-modern:focus {
    border-color: #667eea;
    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
    background: #fff;
  }

  .form-select.form-control-modern {
    border: 2px solid #e9ecef;
    border-radius: 10px;
    padding: 12px 16px;
    background: #fff;
  }

  .btn-modern {
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
  }

  .btn-modern:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  .badge-soft {
    background: rgba(40, 167, 69, 0.1);
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.2);
  }

  .signature-preview-img {
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }

  .empty-state-icon {
    opacity: 0.6;
  }

  .card {
    border-radius: 15px;
    overflow: hidden;
  }

  .shadow-sm {
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08) !important;
  }

  .shadow-lg {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
  }

  .border-0 {
    border: none !important;
  }

  .action-buttons .btn {
    font-weight: 600;
  }

  .form-label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
  }

  .text-primary {
    color: #667eea !important;
  }

  .text-success {
    color: #28a745 !important;
  }

  .text-warning {
    color: #ffc107 !important;
  }

  .bg-primary {
    background-color: #667eea !important;
  }

  .bg-success {
    background-color: #28a745 !important;
  }

  .bg-warning {
    background-color: #ffc107 !important;
  }
`;

// Inyectar estilos
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = customStyles;
  document.head.appendChild(styleElement);
}

const UserEdit = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const param = useParams();
  const str = param.id; 
  const usersId = Number(str);
  const URL = process.env.REACT_APP_API_URL;
  const url = URL.split("/api");

  useEffect(() => {
      dispatch(userList())
    },[dispatch]);

  const results = props.user.results;
  const userId = results && results.filter(item => item.id === usersId )
console.log(userId);

  const username1 = userId && userId.map(item => item.username);
  const firstName = userId && userId.map(item => item.first_name);
  const lastName =  userId && userId.map(item => item.last_name);
  const password = userId && userId.map(item => item.password)
  const email1 = userId && userId.map(item => item.email)
  
  // Extraer campos adicionales
  const contactType1 = userId && userId.map(item => item.contactType);
  const codigoCAUAGENT1 = userId && userId.map(item => {
    // Si es un string JSON, parsearlo; si es array, devolverlo; si no, array vacío
    if (typeof item.codigoCAUAGENT === 'string' && item.codigoCAUAGENT.startsWith('[')) {
      try {
        return JSON.parse(item.codigoCAUAGENT);
      } catch {
        return item.codigoCAUAGENT ? [item.codigoCAUAGENT] : [];
      }
    }
    return Array.isArray(item.codigoCAUAGENT) ? item.codigoCAUAGENT : (item.codigoCAUAGENT ? [item.codigoCAUAGENT] : []);
  });
  const codigoVisitador1 = userId && userId.map(item => item.codigo_visitador);
  const cargo1 = userId && userId.map(item => item.cargo);
  const firma1 = userId && userId.map(item => item.firma);
  const esTitular1 = userId && userId.map(item => item.es_titular);
  const zonaTitular1 = userId && userId.map(item => {
    // Si es un string JSON, parsearlo; si es array, devolverlo; si no, array vacío
    if (typeof item.zona_titular === 'string' && item.zona_titular.startsWith('[')) {
      try {
        return JSON.parse(item.zona_titular);
      } catch {
        return item.zona_titular ? [item.zona_titular] : [];
      }
    }
    return Array.isArray(item.zona_titular) ? item.zona_titular : (item.zona_titular ? [item.zona_titular] : []);
  });

  // Cargar firma existente cuando se cargan los datos del usuario
  useEffect(() => {
    if (firma1 && firma1[0] && firma1[0] !== "undefined") {
      setExistingSignature(firma1[0]);
    }
  }, [firma1]);
  const [formData, setFormData] = useState({
    username: String(username1),
    first_name: String (firstName),
    last_name: String(lastName),
    email: String(email1),
    contactType: String(contactType1) !== "undefined" ? String(contactType1) : "PERSONA NATURAL",
    codigoCAUAGENT: codigoCAUAGENT1 && codigoCAUAGENT1[0] ? codigoCAUAGENT1[0] : [],
    codigo_visitador: String(codigoVisitador1) !== "undefined" ? String(codigoVisitador1) : "",
    cargo: String(cargo1) !== "undefined" ? String(cargo1) : "",
    es_titular: esTitular1 && esTitular1[0] ? Boolean(esTitular1[0]) : false,
    zona_titular: zonaTitular1 && zonaTitular1[0] ? zonaTitular1[0] : [],
    firma: null
  });

  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatureFile, setSignatureFile] = useState(null);
  const [existingSignature, setExistingSignature] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [isUpdatingFields, setIsUpdatingFields] = useState(false);

  const { username, first_name, last_name, email, contactType, codigoCAUAGENT, codigo_visitador, cargo, es_titular, zona_titular } =
    formData;

  const onChange = (e) => {
    if (e.target.name === 'codigoCAUAGENT') {
      // Manejar selección múltiple para codigoCAUAGENT
      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, [e.target.name]: selectedOptions });
    } else if (e.target.name === 'zona_titular') {
      // Manejar selección múltiple para zona_titular
      const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, [e.target.name]: selectedOptions });
    } else if (e.target.name === 'es_titular') {
      // Manejar checkbox para es_titular
      const isChecked = e.target.checked;
      setFormData({ 
        ...formData, 
        [e.target.name]: isChecked,
        // Si se desmarca es_titular, limpiar zona_titular
        zona_titular: isChecked ? formData.zona_titular : []
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSignatureSave = (signatureFile) => {
    setSignatureFile(signatureFile);
    setFormData({ ...formData, firma: signatureFile });
    setShowSignatureModal(false);
    toast.success("Firma guardada exitosamente");
  };

  const handleRemoveSignature = () => {
    setSignatureFile(null);
    setExistingSignature(null);
    setFormData({ ...formData, firma: null });
    toast.info("Firma eliminada");
  };

  const getSignatureUrl = (signaturePath) => {
    if (!signaturePath) return null;
    return `${url[0]}${signaturePath}`;
  };


  const onSubmit = async (e) => {
    e.preventDefault();
    setIsUpdatingFields(true);

    try {
      // Primera petición: Actualizar datos básicos del usuario (username, nombres, apellidos)
      const basicUserData = {
        username,
        first_name,
        last_name,
        password: String(password),
        email,
      };

      await props.userUpdate(usersId, basicUserData);
      toast.success('Información básica actualizada exitosamente');

      // Segunda petición: Actualizar campos específicos usando postUserUpdate
      const specificFieldsData = {
        user_id: usersId,
        contactType: contactType,
        codigo_visitador: codigo_visitador,
        cargo: cargo,
        codigoCAUAGENT: JSON.stringify(codigoCAUAGENT),
        es_titular: es_titular,
        zona_titular: JSON.stringify(zona_titular)
      };

      console.log('Datos específicos a enviar:', specificFieldsData);
      console.log('¿Hay archivo de firma?', !!signatureFile);

      // Siempre enviar como FormData (el servidor espera este formato)
      console.log('Enviando como FormData');
      const formDataToSend = new FormData();
      Object.keys(specificFieldsData).forEach(key => {
        formDataToSend.append(key, specificFieldsData[key]);
      });
      
      // Solo agregar la firma si existe
      if (signatureFile) {
        console.log('Agregando archivo de firma');
        formDataToSend.append('firma', signatureFile);
      }
      
      await postUserUpdate(formDataToSend);

      toast.success('Campos específicos actualizados exitosamente');
      setUpdateSuccess(true);
      
      // Refrescar la lista de usuarios
      dispatch(userList());
      
      setTimeout(() => {
        setUpdateSuccess(false);
      }, 5000);

    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      toast.error('Error al actualizar el usuario: ' + (error.message || 'Error desconocido'));
    } finally {
      setIsUpdatingFields(false);
    }
  };

  const redirect = () => {
    history.push("/users");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cuidad Limpia | Usuarios </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Col className="d-flex gap-3 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Editando Usuario
            </span>
          </Col>
          {props.loading ? (
            <Loader />
          ) : (
            <div className="row">
              <div className="col-lg-10 mx-auto">
                {/* Alertas de éxito y error */}
                {props.userUpdated.id ? (
                  <SweetAlert
                    title="¡Perfecto!"
                    success
                    timeout={2000}
                    showConfirm={false}
                    onConfirm={() => redirect()}
                  >
                    Usuario actualizado exitosamente
                  </SweetAlert>
                ) : null}
                
                {updateSuccess && (
                  <Alert color="success" className="mb-4">
                    <i className="mdi mdi-check-circle me-2"></i>
                    Los campos específicos han sido actualizados correctamente
                  </Alert>
                )}
                
                {props.error.detail ? (
                  <SweetAlert
                    title="Error"
                    error
                    showConfirm={true}
                    onConfirm={() => redirect()}
                  >
                    {props.error.detail}
                  </SweetAlert>
                ) : null}

                <div className="user-edit-container">
                  {/* Header con gradiente */}
                  {updateSuccess && (
                    <Alert color="success" className="mb-4 border-0 shadow-sm">
                      <div className="d-flex align-items-center">
                        <i className="mdi mdi-check-circle-outline me-2" style={{ fontSize: '1.5rem' }}></i>
                        <div>
                          <strong>¡Éxito!</strong> Usuario actualizado correctamente
                        </div>
                      </div>
                    </Alert>
                  )}

                  <Form onSubmit={onSubmit}>
                    <Row>
                      {/* Columna Principal */}
                      <Col lg={8}>
                        {/* Información Básica */}
                        <Card className="mb-4 border-0 shadow-sm">
                          <CardHeader className=" border-bottom-0 pb-0">
                            <div className="section-header">
                              <div className="section-icon bg-primary">
                                <i className="mdi mdi-account-circle text-white"></i>
                              </div>
                              <div>
                                <h5 className="mb-1 fw-bold">Información Básica</h5>
                                <p className="text-muted small mb-0">Datos principales del usuario</p>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="pt-3">
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="username" className="form-label fw-semibold">
                                    <i className="mdi mdi-account me-1 text-primary"></i>
                                    Usuario
                                  </Label>
                                  <Input
                                    type="text"
                                    name="username"
                                    id="username"
                                    placeholder="Nombre de usuario"
                                    value={username}
                                    onChange={onChange}
                                    className="form-control-modern"
                                    invalid={props.error?.username ? true : false}
                                  />
                                  <FormFeedback>{props.error.username}</FormFeedback>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="email" className="form-label fw-semibold">
                                    <i className="mdi mdi-email me-1 text-primary"></i>
                                    Email
                                  </Label>
                                  <Input
                                    type="email"
                                    name="email"
                                    id="email"
                                    placeholder="Correo electrónico"
                                    value={email}
                                    onChange={onChange}
                                    className="form-control-modern"
                                    disabled
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="first_name" className="form-label fw-semibold">
                                    <i className="mdi mdi-account-outline me-1 text-primary"></i>
                                    Nombres
                                  </Label>
                                  <Input
                                    type="text"
                                    name="first_name"
                                    id="first_name"
                                    placeholder="Nombres"
                                    value={first_name}
                                    onChange={onChange}
                                    className="form-control-modern"
                                    invalid={props.error?.first_name ? true : false}
                                  />
                                  <FormFeedback>{props.error.first_name}</FormFeedback>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-0">
                                  <Label for="last_name" className="form-label fw-semibold">
                                    <i className="mdi mdi-account-outline me-1 text-primary"></i>
                                    Apellidos
                                  </Label>
                                  <Input
                                    type="text"
                                    name="last_name"
                                    id="last_name"
                                    placeholder="Apellidos"
                                    value={last_name}
                                    onChange={onChange}
                                    className="form-control-modern"
                                    invalid={props.error?.last_name ? true : false}
                                  />
                                  <FormFeedback>{props.error.last_name}</FormFeedback>
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>

                        {/* Información Profesional */}
                        <Card className="mb-4 border-0 shadow-sm">
                          <CardHeader className=" border-bottom-0 pb-0">
                            <div className="section-header">
                              <div className="section-icon bg-success">
                                <i className="mdi mdi-briefcase text-white"></i>
                              </div>
                              <div>
                                <h5 className="mb-1 fw-bold">Información Profesional</h5>
                                <p className="text-muted small mb-0">Datos laborales y códigos</p>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="pt-3">
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="contactType" className="form-label fw-semibold">
                                    <i className="mdi mdi-account-group me-1 text-success"></i>
                                    Tipo de Contacto
                                  </Label>
                                  <select
                                    className="form-select form-control-modern"
                                    id="contactType"
                                    name="contactType"
                                    value={contactType}
                                    onChange={onChange}
                                  >
                                    <option value="PERSONA NATURAL">Persona Natural</option>
                                    <option value="VISITADOR">Visitador</option>
                                    <option value="PATINADOR">Patinador</option>
                                    <option value="COORDINADOR">Coordinador</option>
                                    <option value="PROFESIONAL">Profesional</option>
                                    <option value="EMPRESA">Empresa</option>
                                  </select>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="cargo" className="form-label fw-semibold">
                                    <i className="mdi mdi-badge-account me-1 text-success"></i>
                                    Cargo
                                  </Label>
                                  <Input
                                    type="text"
                                    name="cargo"
                                    id="cargo"
                                    placeholder="Cargo o posición"
                                    value={cargo}
                                    onChange={onChange}
                                    className="form-control-modern"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="codigoCAUAGENT" className="form-label fw-semibold">
                                    <i className="mdi mdi-map-marker me-1 text-success"></i>
                                    Polígono
                                  </Label>
                                  <Input
                                    type="select"
                                    name="codigoCAUAGENT"
                                    id="codigoCAUAGENT"
                                    value={codigoCAUAGENT}
                                    onChange={onChange}
                                    className="form-control-modern"
                                    multiple
                                    style={{ minHeight: '120px' }}
                                  >
                                    <option value="F1T">F1T</option>
                                    <option value="F2M">F2M</option>
                                    <option value="F3A">F3A</option>
                                    <option value="F4P">F4P</option>
                                    <option value="K1C">K1C</option>
                                    <option value="K2P">K2P</option>
                                    <option value="K3B">K3B</option>
                                    <option value="K4C">K4C</option>
                                    <option value="K5T">K5T</option>
                                    <option value="K6I">K6I</option>
                                  </Input>
                                  <small className="text-muted mt-1 d-block">
                                    Mantén presionado Ctrl (Cmd en Mac) para seleccionar múltiples opciones
                                  </small>
                                </div>
                              </Col>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label for="codigo_visitador" className="form-label fw-semibold">
                                    <i className="mdi mdi-card-account-details me-1 text-success"></i>
                                    Código Visitador
                                  </Label>
                                  <Input
                                    type="text"
                                    name="codigo_visitador"
                                    id="codigo_visitador"
                                    placeholder="Código de visitador"
                                    value={codigo_visitador}
                                    onChange={onChange}
                                    className="form-control-modern"
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <div className="form-check">
                                    <Input
                                      type="checkbox"
                                      name="es_titular"
                                      id="es_titular"
                                      checked={es_titular}
                                      onChange={onChange}
                                      className="form-check-input"
                                    />
                                    <Label for="es_titular" className="form-check-label fw-semibold">
                                      <i className="mdi mdi-crown me-1 text-warning"></i>
                                      Es Titular
                                    </Label>
                                  </div>
                                </div>
                              </Col>
                              {es_titular && (
                                <Col md={6}>
                                  <div className="mb-0">
                                    <Label for="zona_titular" className="form-label fw-semibold">
                                      <i className="mdi mdi-map-marker me-1 text-warning"></i>
                                      Zona Titular
                                    </Label>
                                    <Input
                                      type="select"
                                      name="zona_titular"
                                      id="zona_titular"
                                      value={zona_titular}
                                      onChange={onChange}
                                      className="form-control-modern"
                                      multiple
                                      style={{ minHeight: '120px' }}
                                    >
                                      <option value="F1T">F1T</option>
                                      <option value="F2M">F2M</option>
                                      <option value="F3A">F3A</option>
                                      <option value="F4P">F4P</option>
                                      <option value="K1C">K1C</option>
                                      <option value="K2P">K2P</option>
                                      <option value="K3B">K3B</option>
                                      <option value="K4C">K4C</option>
                                      <option value="K5T">K5T</option>
                                      <option value="K6I">K6I</option>
                                    </Input>
                                    <small className="text-muted mt-1 d-block">
                                      Mantén presionado Ctrl (Cmd en Mac) para seleccionar múltiples opciones
                                    </small>
                                  </div>
                                </Col>
                              )}
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>

                      {/* Columna Lateral */}
                      <Col lg={4}>
                        {/* Firma Digital */}
                        <Card className="mb-4 border-0 shadow-sm">
                          <CardHeader className=" border-bottom-0 pb-0">
                            <div className="section-header">
                              <div className="section-icon bg-warning">
                                <i className="mdi mdi-draw text-white"></i>
                              </div>
                              <div>
                                <h5 className="mb-1 fw-bold">Firma Digital</h5>
                                <p className="text-muted small mb-0">Gestión de firma</p>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="pt-3">
                            {existingSignature && !signatureFile ? (
                              <div className="signature-preview-modern">
                                <div className="signature-image-container mb-3">
                                  <img
                                    src={getSignatureUrl(existingSignature)}
                                    alt="Firma actual"
                                    className="signature-preview-img"
                                    style={{
                                      maxWidth: '100%',
                                      maxHeight: '120px',
                                      border: '1px solid #dee2e6',
                                      borderRadius: '8px',
                                      backgroundColor: 'white',
                                      display: 'block',
                                      margin: '0 auto'
                                    }}
                                  />
                                </div>
                                <div className="signature-actions">
                                  <Button
                                    type="button"
                                    color="primary"
                                    size="sm"
                                    className="w-100 mb-2 btn-modern"
                                    onClick={() => setShowSignatureModal(true)}
                                  >
                                    <i className="mdi mdi-pencil me-1"></i>
                                    Modificar Firma
                                  </Button>
                                  <Button
                                    type="button"
                                    color="danger"
                                    size="sm"
                                    outline
                                    className="w-100 btn-modern"
                                    onClick={handleRemoveSignature}
                                  >
                                    <i className="mdi mdi-delete me-1"></i>
                                    Eliminar Firma
                                  </Button>
                                </div>
                              </div>
                            ) : signatureFile ? (
                              <div className="mb-3">
                                <Alert color="info">
                                  <i className="mdi mdi-information me-2"></i>
                                  Nueva firma seleccionada. Guarda los cambios para aplicarla.
                                  <div className="mt-2">
                                    <Button
                                      type="button"
                                      color="warning"
                                      size="sm"
                                      outline
                                      onClick={() => setSignatureFile(null)}
                                    >
                                      <i className="mdi mdi-close me-1"></i>
                                      Cancelar cambio
                                    </Button>
                                  </div>
                                </Alert>
                              </div>
                            ) : (
                              <div className="signature-empty-modern text-center">
                                <div className="empty-state-icon mb-3">
                                  <i className="mdi mdi-draw" style={{ fontSize: '3rem', color: '#6c757d' }}></i>
                                </div>
                                <h6 className="text-muted mb-2">Sin firma</h6>
                                <p className="text-muted small mb-3">
                                  Agregue su firma digital
                                </p>
                                <Button
                                  type="button"
                                  color="warning"
                                  className="w-100 btn-modern"
                                  onClick={() => setShowSignatureModal(true)}
                                >
                                  <i className="mdi mdi-plus me-1"></i>
                                  Agregar Firma
                                </Button>
                              </div>
                            )}
                          </CardBody>
                        </Card>

                        {/* Acciones */}
                        <Card className="border-0 shadow-sm">
                          <CardBody>
                            <div className="action-buttons">
                              <Button
                                type="submit"
                                color="primary"
                                disabled={isUpdatingFields}
                                className="w-100 mb-2 btn-modern btn-lg"
                              >
                                {isUpdatingFields ? (
                                  <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    Actualizando...
                                  </>
                                ) : (
                                  <>
                                    <i className="mdi mdi-content-save me-1"></i>
                                    Guardar Cambios
                                  </>
                                )}
                              </Button>
                              <Link to="/users" className="btn btn-light w-100 btn-modern">
                                <i className="mdi mdi-arrow-left me-1"></i>
                                Volver
                              </Link>
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          )}
        </Container>
      </div>

      {/* Modal de Firma Digital */}
      <SignatureModal
        isOpen={showSignatureModal}
        onClose={() => setShowSignatureModal(false)}
        onSave={handleSignatureSave}
        title="Gestión de Firma Digital"
      />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, user, userUpdated } = state.User;
  return { error, loading, user, userUpdated };
};

UserEdit.propTypes = {
  error: PropTypes.any,
  loading: PropTypes.bool,
  userUpdated: PropTypes.object,
};
export default withRouter(connect(mapStateToProps, { userList, userUpdate })(UserEdit));
